import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../static/css/inventory.css';
import NavBar from '../components/navBar';
import Cards from '../components/card';
import Footer from '../components/footer';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../components/cart/cartProvider';
import useFetch from '../api/api';
import { Carousel } from "react-bootstrap";

const REACT_APP_API_URL = process.env.REACT_APP_API_URL;
const REACT_APP_MEDIA_URL = process.env.REACT_APP_MEDIA_URL;

function CategorySelector({onCategorySelect}) {
    const {loading, error, data:categories} = useFetch(`${REACT_APP_API_URL}categories`);
    if (loading) return <p>Loading categories...</p>;
    if (error) return <p>{error}</p>;
    return (
        <div className='container mt-5 pt-5'>
            <ul className="justify-content-center list-group list-group-horizontal-md custom-category-bar" style={{border: "none", listStyleType: "none", backgroundColor: "hsla(0,0%,60%,1)"}}>
                <li className={"text-center unround-border list-group-item border-start border-end border-dark-subtle ps-3 pe-3 m-0"} onClick={() => onCategorySelect(null)}>
                    <Link className="nav-link">All</Link>
                </li>
                {(categories?.data||[]).map((category) => (
                    <li key={category.id} className={"text-center unround-border list-group-item border-start border-end border-dark-subtle ps-3 pe-3 m-0"} onClick={() => onCategorySelect(category.id)}>
                        <Link className="nav-link"  >{category.flowerCategory}</Link>
                    </li>
                ))}
            </ul>
        </div>
    );
}

function InventorySection() {
    // inventory state list of:
    // products
    //product: title, productID, Description, Price, productImage
    //the view requires: title, Price, Image
    //sweetwoodflora.shop/api/products?populate=*&filters[category][flowerCategory][$eq]=Roses
    const location = useLocation()
    const defaultURL = `${REACT_APP_API_URL}products?populate=*&pagination[limit]=100`;
    const [url, setUrl] = useState(location.state?.arg?.category?`${REACT_APP_API_URL}products?filters[categories][flowerCategory][$eq]=${location.state?.arg?.category}&populate=*`:defaultURL);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const {loading, error, data} = useFetch(url);
    const [showModal, setShowModal] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);

    const handleCategorySelect = (categoryID) => {
        setSelectedCategory(categoryID);
        const newUrl = categoryID
        ?`${REACT_APP_API_URL}products?filters[categories][id][$eq]=${categoryID}&populate=*`
        :defaultURL;
        setUrl(newUrl)
    };

    const handleShowModal = (product) => {
        setSelectedProduct(product);
        setShowModal(true);
    };
    
    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedProduct(null);
    };

    if (loading) return (<p>Loading</p>);
    if (error) return (
        <p>Error!</p>
    );

    const products = data?.data || [];
    const sortedProducts = products.sort((a, b) => {
        const numA = a.Priority ? parseInt(a.Priority.substring(1), 10) : Infinity;
        const numB = b.Priority ? parseInt(b.Priority.substring(1), 10) : Infinity;
        return numA - numB; // Sort in descending order
    });
    return (
        <div>
            <CategorySelector onCategorySelect={handleCategorySelect}/>
            <div className='container-fluid my-5 p-0 border-top border-light-subtle border-2' style={{maxWidth: "90vw"}}>
                <div className="row justify-content-start py-3 mx-0 my-5 flex-wrap p-0">
                    {sortedProducts.map((product) => {
                        try {
                            const productImages = product.productImage.map(img => `${REACT_APP_MEDIA_URL}${img.url}`);
                            return (
                                <Cards 
                                    context={"i"} 
                                    price={product.Price.toFixed(2)} 
                                    className={"card card-custom col-6 px-2 col-sm-3 px-sm-5 px-0 text-light"} 
                                    key={product.id} 
                                    images={productImages} 
                                    alt={product.title} 
                                    text={product.title}
                                    onclick={() => handleShowModal(product)}
                                    discount={product.discount}
                                    />);
                        } catch {
                            console.log("Image Missing");
                        }
                    })}
                </div>
            </div>
            {selectedProduct && (
                <ProductModal
                show={showModal}
                onClose={handleCloseModal}
                product={selectedProduct}
                />
            )}
        </div>
    );
}

function InventoryNote(){
    const {loading, error, data: inventoryNote} = useFetch(`${REACT_APP_API_URL}textnotes?filters[name][$eq]=inventorynote`);
    return (
        <p style={{fontSize: "1.5rem"}}>
            {inventoryNote?.data[0].text}
        </p>
    )
}

function InventoryNoteSection() {
    return (
        <div className="container-fluid mt-3 m-0 p-0" style={{backgroundColor: "hsla(0,0%,60%,1)"}}>
            <div className='container text-center' style={{color: "white"}}>
                <p style={{fontSize: "3rem", fontWeight: "500"}}>
                    Our Plants
                </p>
                <InventoryNote/>
            </div>
        </div>
    );
}

const ProductModal = ({ show, onClose, product }) => {
    const { addToCart, cartItems } = useCart();
    const images = product.productImage.map(img => `${REACT_APP_MEDIA_URL}${img.url}`);
    const handleAddToCart = (product, addOns) => {
        addToCart({...product,quantity: 1, addOns });
    };
    const [selectedAddons, setSelectedAddons] = useState([]);
    const handleAddonChange = (event, addon) => {
    if (event.target.checked) {
        setSelectedAddons([...selectedAddons, addon]);
    } else {
        setSelectedAddons(selectedAddons.filter((item) => item.name !== addon.name));
    }
    };

    const local = product.local;
    if (!show) return null;
    const descriptionText = product.Description
    .map((desc) =>
        desc.children.map((child) => child.text).join("")
    )
    .join("\n\n");
    return (
      <div
        className="modal fade show"
        style={{ display: "block"}}
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered custom-modal mx-auto" role="document">
          <div className="modal-content" style={{backgroundColor: "rgb(156, 156, 150)", zIndex: "2000", color: "beige"}}>
            <div className="modal-header justify-content-end">
              <button
                type="button"
                className="btn-close mx-0"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body d-flex flex-column align-items-center justify-content-center">
              <div className='d-flex flex-column flex-md-row justify-content-center my-4'>
                <div style={{width: "100%", height: "100%"}}>
                    {images.length === 1 ? (
                        <img src={images[0]} className="img-fluid modal-img" alt={product.alt}/>
                    ) : (
                        <Carousel controls={true} indicators={true} interval={null}>
                            {images.map((img, index) => (
                                <Carousel.Item key={index}>
                                    <img src={img} className="img-fluid modal-img" alt={`${product.title}-${product.index}`}/>
                                </Carousel.Item>
                            ))}
                        </Carousel>
                    )}
                </div>
                
                <div className='mx-3' style={{width: "100%"}}>
                    <h1 className="modal-title mx-auto text-center fst-italic" style={{fontSize: "clamp(1.5rem, 2vw, 3rem)"}}>{product.title}</h1>
                    {local && (<p className="text-center mb-5 text-dark">* This product is only available for local (Greater Houston Area) delivery</p>)}
                    <p style={{textIndent: "2rem", fontSize: "clamp(1rem, 2.5vw, 1.5rem)"}}>{descriptionText}</p>
                    {product.AddOn.length > 0 && (
                    <div className="container border border-white mt-4 p-3 mb-0">
                        <p className="text-white" style={{fontSize: "clamp(2rem,2.5vw,3rem)"}}>Add-Ons:</p>
                        {product.AddOn.map((addon) => (
                        <div key={addon.id} className="d-flex align-items-center">
                            <input 
                            type="checkbox" 
                            id={addon.id} 
                            onChange={(e) => handleAddonChange(e, addon)}
                            />
                            <label htmlFor={addon.id} className="text-white ms-2" style={{fontSize: "clamp(1rem,1.5vw,1.5rem)"}}>
                            {addon.Name} - ${addon.Price.toFixed(2)}
                            </label>
                        </div>
                        ))}
                    </div>
                    )}
                </div>
              </div>
              <p style={{fontSize: "clamp(1rem, 2.5vw, 2rem)"}}>Price: ${product.Price.toFixed(2)}</p>
            </div>
            <div className="modal-footer justify-content-center">
              <button className="btn btn-dark" onClick={()=>{handleAddToCart(product,selectedAddons); onClose();}}>Add to Cart</button>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show" onClick={onClose}></div>
      </div>
    );
  };
  

function InventoryPage() {
    return(
        <div>
            <NavBar/>
            <InventoryNoteSection/>
            <InventorySection/>
            <Footer/>
        </div>
    );
}
export default InventoryPage;